import type { FC } from 'react';
import React from 'react';
import { generatePath } from 'react-router-dom';
import { Typography } from '@mui/material';
import { Link } from '@pflegenavi/web-components';
import { nhAppMainPages } from '@pflegenavi/frontend/routing';
import { useEmployeeIsNursingHomeAdminOrManager } from '@pflegenavi/frontend/nursing-home-context';

export const ServiceProviderLink: FC<{ id?: string; name: string }> = ({
  id,
  name,
}) => {
  const isAdminOrManager = useEmployeeIsNursingHomeAdminOrManager();

  if (!id || !isAdminOrManager) {
    return <>{name}</>;
  }

  return (
    <Link
      to={generatePath(nhAppMainPages.SERVICE_PROVIDER_DETAILS, {
        serviceProviderId: id,
      })}
      onClick={(e) => e.stopPropagation()}
    >
      <Typography variant="subtitle2" noWrap>
        {name}
      </Typography>
    </Link>
  );
};
